module.exports = __webpack_public_path__ + "static/media/cat.042d414c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pet_icons/cat.svg
// module id = 62
// module chunks = 0